export default __webpack_public_path__ + "static/media/lol_banner_highlight.5d2d2be3.png";